export default "__VITE_ASSET__3ae3c78d__"